"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const cleanDatabasePath_1 = __importDefault(require("../FirebaseDatabaseCache/cleanDatabasePath"));
const getValueByPathFromUnknown_1 = __importDefault(require("./getValueByPathFromUnknown"));
const appStateSelectAppId_1 = __importDefault(require("./appStateSelectAppId"));
const appStateSelectLocalStorageData_1 = __importDefault(require("./appStateSelectLocalStorageData"));
const appStateBuildMiddlewareLocalStorage = (localStorate) => (store) => (next) => (action) => {
    const localDataBefore = (0, appStateSelectLocalStorageData_1.default)(store.getState());
    const nextAction = next(action);
    const stateAfter = store.getState();
    const localDataAfter = (0, appStateSelectLocalStorageData_1.default)(stateAfter);
    const appId = (0, appStateSelectAppId_1.default)(stateAfter);
    if (localDataAfter !== localDataBefore) {
        if (!localDataAfter) {
            localStorate.removeItem(`dbLocalStorage:${appId}`);
        }
        else {
            localStorate.setItem(`dbLocalStorage:${appId}`, JSON.stringify(localDataAfter));
        }
        const { listeners, lastUpdates } = stateAfter.localStorage;
        if (lastUpdates && localDataAfter !== undefined) {
            const originPaths = Object.keys(lastUpdates);
            Object.entries(listeners).forEach(([path, listenersArray]) => {
                if (!listenersArray) {
                    return;
                }
                const hasPath = originPaths.find((originPath) => originPath.startsWith(path));
                if (hasPath) {
                    const formatedPath = (0, cleanDatabasePath_1.default)(path);
                    const dataOnListeners = (0, getValueByPathFromUnknown_1.default)(localDataAfter, formatedPath.split('/'));
                    listenersArray.forEach((listener) => {
                        listener(dataOnListeners);
                    });
                }
            });
        }
        else {
            Object.entries(listeners).forEach(([, listenersArray]) => {
                if (listenersArray) {
                    listenersArray.forEach((listener) => {
                        listener(undefined);
                    });
                }
            });
        }
    }
    return nextAction;
};
exports.default = appStateBuildMiddlewareLocalStorage;
